"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../types");
const { NODE_ENV, GRID_SIGNALS_API, REACT_APP_GRID_SIGNALS_API } = process.env;
const getBaseUrl = (dataResidency) => {
    if (GRID_SIGNALS_API) {
        return GRID_SIGNALS_API;
    }
    if (REACT_APP_GRID_SIGNALS_API) {
        return REACT_APP_GRID_SIGNALS_API;
    }
    if (NODE_ENV === 'development') {
        return 'https://api.griddeveloper.com/regions/dev/signals/v1';
    }
    switch (dataResidency) {
        case types_1.DataResidencyEnum.AU:
            return 'https://api.omborigrid.com/regions/au/signals/v1';
        case types_1.DataResidencyEnum.EU:
            return 'https://api.omborigrid.com/regions/eu/signals/v1';
        case types_1.DataResidencyEnum.IN:
            return 'https://api.omborigrid.com/regions/in/signals/v1';
        case types_1.DataResidencyEnum.UAE:
            return 'https://api.omborigrid.com/regions/uae/signals/v1';
        case types_1.DataResidencyEnum.US:
            return 'https://api.omborigrid.com/regions/us/signals/v1';
        default:
            throw new Error('Invalid data residency');
    }
};
exports.default = getBaseUrl;
